<template>
<div class="users">

    <div class="page-header">
        <h1><lang labelKey="HEADER_USERS"></lang></h1>
    </div>

    <loading-indicator :loading="isLoading"></loading-indicator>

    <div class="columns" v-if="!isLoading">

		<div class="col-main">

			<v-client-table ref="tblUsers" name="tblUsers" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tblUsers noFirstColumn">

                <!-- before table: FILTER OPTIONS -->
                <template slot="beforeTable">
                    <div class="columns is-marginless filters">
                        <!--search -->
                        <div class="column is-narrow">
                            <div class="control has-icon search">
                                <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- delete -->
                <template slot="delete" slot-scope="props">

                    <pop-confirm class="icon is-small" content="Soll dieser Benutzer wirklich entfernt werden?" icon="question-circle-o" :on-ok="function() { deleteUser(props.row.id) }" cancel-text="nein" title="Benutzer löschen">
                        <i class="icon-ak-entfernen"></i>
                    </pop-confirm>

                </template>

            </v-client-table>

		</div>

		<div class="col-aside">

			<affix :offset="50">
    			<div class="sidebox">
                    <custom-button type="blue" icon="icon-ak-hinzufuegen" @click.native="newUser" name="USER_NEW_USER"></custom-button>
    			</div>
            </affix>

		</div>

    </div>


</div>
</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

    name: 'users',

    data() {
        var self = this;

		return {
            selectedLetter: '',
            searchString: null,
            isLoading: false,
            table: {
                tblData: [],
                tblColumns: ['username', 'email', 'firstname', 'lastname', 'userRole', 'delete'],
                tblOptions: {

                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: true,
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

                    perPage: 25,

                    orderBy: {
                        ascending: true,
                        column: 'username'
                    },

                    headings: {
                        username: function(h) {
    						return <lang labelKey="USER_TBL_HEADER-USERNAME"></lang>
    					},
    					firstname: function(h) {
    						return <lang labelKey="USER_TBL_HEADER-FIRSTNAME"></lang>
    					},
    					lastname: function(h) {
    						return <lang labelKey="USER_TBL_HEADER-LASTNAME"></lang>
    					},
    					email: function(h) {
    						return <lang labelKey="USER_TBL_HEADER-EMAIL"></lang>
    					},
	                	userRole: function(h) {
    						return <lang labelKey="USER_TBL_HEADER-USERROLE"></lang>
    					},
                        delete: function(h) {
                            return <lang labelKey="USER_TBL_HEADER-DELETE"></lang>
                        }
                    },

					sortable: ['id', 'username', 'lastname', 'email', 'userRole'],

                    templates: {
                        userRole: function(h, row) {
                            return row.userRole ? row.userRole.name : '';
                        },
			        },

					texts: {
						filter: 'Filter Ergebnisse:',
						filterPlaceholder: 'Suche',
						limit: 'Einträge pro Seite',
						noResults: 'keine passenden Einträge gefunden',
						count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
					},

					pagination: {
						chunk: 5
					},

                    filterByColumn: false,
					filterable: false,
                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
					customFilters: [
						{
							name: 'search',
							callback(row, string) {

								if(string == null || string == "") {
									return true;
								}

								string = string.toLowerCase();

                                return row.username != null && row.username.toLowerCase().indexOf(string) > -1
                                    || row.firstname != null  && row.firstname.toLowerCase().indexOf(string) > -1
                                    || row.firstname != null && row.lastname.toLowerCase().indexOf(string) > -1
                                    || row.email != null && row.email.toLowerCase().indexOf(string) > -1;

							}
						},
                    ],

					customSorting: {

                        userRole: function(ascending) {
                            return function(rowA, rowB) {
                                var a = rowA.userRole ? rowA.userRole.name : '';
                                var b = rowB.userRole ? rowB.userRole.name : '';

                                if(ascending) {
                                    return a <= b ? 1 : -1;
                                }
                                return a >= b ? 1 : -1;
                            }
                        },

                    },

                    rowClassCallback: function(row) {
						return `row-${row.id}`;
					}

                }
            },

		}
	},

    created() {

		this.fetchData();

	},

    computed: {

        users() {

            return this.table.tblData.filter(user => user.enabled == true);

        }

    },

    mounted() {

        Event.$on('vue-tables.tblUsers.row-click', function (data) {
            if(data.row.email != undefined) {
                this.editUser(data.row.id);
            }
		}.bind(this));

	},

    watch: {

        searchString(newVal, oldVal) {
            Event.$emit('vue-tables.tblUsers.filter::search', newVal);
		},

    },


    methods: {

        deleteUser(userId) {

            var rowIndex = this.table.tblData.findIndex(function(user) {
                if(typeof user != 'undefined') {
                    return user.id == userId;
                }
            });

            /*
            this.table.tblData.forEach(function(user, index) {
                if(user.id == userId) {
                    rowIndex = index;
                }
            })
            */

            var self = this;
            this.table.tblData[rowIndex].enabled = false;

            // save/update
            this.entityCreateOrUpdate('user', this.table.tblData[rowIndex], { msg: 'Benutzer wurde erfolgreich entfernt!' })
                .then(function(response) {
                    self.table.tblData.splice(rowIndex, 1);
                    // self.$refs.tblUsers.data.splice(rowIndex, 1);
                });

        },

        editUser(userID) {
          this.$router.push({ name: 'userEdit', params: { userID: userID }});

          // this.$router.push('/benutzer/benutzer-' + userID);

        },

        newUser() {
          this.$router.push({ name: 'userNew'});
          // this.$router.push(this.$route.fullPath + '/neu/');
        },

        fetchData() {

            this.isLoading = true;
            var self = this;
            var apiURL = this.$config.api + 'user?include=user.userRole,user.person,user.manufacturer,user.site';

            // fetch data
            this.axios.get(apiURL)
                .then(function(response) {
                    let newTblData = [];

                    response.data.user.forEach(function(user) {
                        if(user.enabled) {
                            user.firstname = user.person != null ? user.person.firstname : "";
                            user.lastname = user.person != null ? user.person.lastname : "";
                            newTblData.push(user);
                        }
                    });

                    self.table.tblData = newTblData;
                    self.isLoading = false;

                }).catch(function(error) {
                    console.log('Error: ', error.message);
                    self.isLoading = false;
                });

        }

    }

}


</script>

<style>

.tblUsers th:first-child {
    max-width: 150px;
    width: 150px;
}
.tblUsers th:last-child {
    width: 100px;
    max-width: 100px;
    text-align: center;
}
.tblUsers td:last-child {
    text-align: center;
}
</style>
